<template>
  <div class="add-item-release-view-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('addItemReleaseView.title')" :subtitle="$t('addItemReleaseView.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-close" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="saveItemReleaseInfo">
          {{ $t('common.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 申请信息面板 -->
    <div class="ds-panel">
      <el-form label-width="150px" label-position="right" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addItemReleaseView.releaseType')">
              <el-select v-model="form.typeId" class="w-full" @change="changeItemReleaseType">
                <el-option disabled :value="''" :label="$t('addItemReleaseView.requiredSelectReleaseType')" />
                <el-option v-for="item in form.itemReleaseTypes" :key="item.typeId" :label="item.typeName"
                  :value="item.typeId" :disabled="item.state !== 'C'" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addItemReleaseView.applyCompany')">
              <el-input v-model="form.applyCompany" :placeholder="$t('addItemReleaseView.requiredApplyCompany')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addItemReleaseView.applyPerson')">
              <el-input v-model="form.applyPerson" :placeholder="$t('addItemReleaseView.requiredApplyPerson')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addItemReleaseView.idCard')">
              <el-input v-model="form.idCard" :placeholder="$t('addItemReleaseView.requiredIdCard')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addItemReleaseView.phone')">
              <el-input v-model="form.applyTel" :placeholder="$t('addItemReleaseView.requiredPhone')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addItemReleaseView.passTime')">
              <el-date-picker v-model="form.passTime" type="datetime" class="w-full" value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('addItemReleaseView.requiredPassTime')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addItemReleaseView.carNum')">
              <el-input v-model="form.carNum" :placeholder="$t('addItemReleaseView.optionalCarNum')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addItemReleaseView.remark')">
              <el-input v-model="form.remark" type="textarea" :placeholder="$t('addItemReleaseView.optionalRemark')" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- (3) 放行物品面板 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('addItemReleaseView.releaseItems') }}</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="addResName">
          {{ $t('addItemReleaseView.addItem') }}
        </el-button>
      </div>
      <ds-data-table :data="form.resNames" border :empty-description="$t('addItemReleaseView.page.emptyItems')">
        <el-table-column :label="$t('addItemReleaseView.itemName')" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.resName" :placeholder="$t('addItemReleaseView.requiredItemName')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('addItemReleaseView.itemAmount')" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.amount" type="number" :placeholder="$t('addItemReleaseView.requiredItemAmount')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="danger" size="small" icon="el-icon-delete" @click="removeResName(scope.row.resName)" />
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <!-- (4) 审批人信息面板 -->
    <div class="ds-panel" v-if="form.audit.assignee === '-2'">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('addItemReleaseView.approverInfo') }}</span>
      </div>
      <div class="ds-panel__body">
        <el-form label-width="150px" label-position="right" class="ds-form">
          <el-row :gutter="16">
            <el-col :xs="24" :sm="12" :md="12">
              <el-form-item :label="$t('addItemReleaseView.approver')">
                <el-input v-model="form.audit.staffName" :placeholder="$t('addItemReleaseView.requiredApprover')"
                  disabled />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12">
              <el-form-item label-width="0">
                <el-button type="primary" icon="el-icon-search" @click="chooseStaff">
                  {{ $t('common.select') }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <SelectStaff ref="selectStaff" @selectStaff="handleStaffSelect" />

    <!-- 表单操作区 -->
    <div class="ds-form-actions ds-form-actions--standalone">
      <el-button type="warning" icon="el-icon-close" @click="goBack">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" icon="el-icon-check" @click="saveItemReleaseInfo">
        {{ $t('common.submit') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import SelectStaff from '@/components/staff/SelectStaff'
import {
  saveItemRelease,
  listItemReleaseType,
  queryFirstAuditStaff
} from '@/api/work/addItemReleaseViewApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'AddItemReleaseView',
  components: {
    SelectStaff,
    DsPageHeader,
    DsDataTable
  },
  data() {
    return {
      form: {
        irId: '',
        typeId: '',
        applyCompany: '',
        applyPerson: '',
        idCard: '',
        applyTel: '',
        passTime: '',
        resNames: [],
        state: '',
        carNum: '',
        remark: '',
        itemReleaseTypes: [],
        audit: {
          assignee: '',
          staffId: '',
          staffName: '',
          taskId: ''
        },
        communityId: ''
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.listItemReleaseTypes()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    validateForm() {
      if (!this.form.typeId) {
        this.$message.error(this.$t('addItemReleaseView.validate.releaseType'))
        return false
      }
      if (!this.form.applyCompany) {
        this.$message.error(this.$t('addItemReleaseView.validate.applyCompany'))
        return false
      }
      if (!this.form.applyPerson) {
        this.$message.error(this.$t('addItemReleaseView.validate.applyPerson'))
        return false
      }
      if (!this.form.idCard) {
        this.$message.error(this.$t('addItemReleaseView.validate.idCard'))
        return false
      }
      if (!this.form.applyTel) {
        this.$message.error(this.$t('addItemReleaseView.validate.phone'))
        return false
      }
      if (!this.form.passTime) {
        this.$message.error(this.$t('addItemReleaseView.validate.passTime'))
        return false
      }
      if (this.form.resNames.length === 0) {
        this.$message.error(this.$t('addItemReleaseView.validate.itemsRequired'))
        return false
      }
      for (const item of this.form.resNames) {
        if (!item.resName || !item.amount) {
          this.$message.error(this.$t('addItemReleaseView.validate.itemInfoRequired'))
          return false
        }
      }
      if (this.form.audit.assignee === '-2' && !this.form.audit.staffId) {
        this.$message.error(this.$t('addItemReleaseView.validate.approverRequired'))
        return false
      }
      return true
    },
    async saveItemReleaseInfo() {
      if (!this.validateForm()) return

      try {
        this.form.communityId = this.communityId
        const res = await saveItemRelease(this.form)
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.goBack()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(this.$t('common.saveFailed'))
      }
    },
    async listItemReleaseTypes() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.communityId
        }
        const res = await listItemReleaseType(params)
        this.form.itemReleaseTypes = res.data
      } catch (error) {
        this.$message.error(this.$t('common.fetchFailed'))
      }
    },
    addResName() {
      this.form.resNames.push({
        resName: '',
        amount: ''
      })
    },
    removeResName(resName) {
      this.form.resNames = this.form.resNames.filter(item => item.resName !== resName)
    },
    async changeItemReleaseType() {
      const selectedType = this.form.itemReleaseTypes.find(
        item => item.typeId === this.form.typeId
      )
      if (selectedType && selectedType.flowId) {
        await this.loadStaffOrg(selectedType.flowId)
      }
    },
    async loadStaffOrg(flowId) {
      try {
        const params = {
          communityId: this.communityId,
          flowId: flowId
        }
        const res = await queryFirstAuditStaff(params)
        if (res.code === 0 && res.data.length > 0) {
          Object.assign(this.form.audit, res.data[0])
          if (!res.data[0].assignee.startsWith('-')) {
            this.form.audit.staffId = res.data[0].assignee
          }
        }
      } catch (error) {
        console.error('Failed to load staff org:', error)
      }
    },
    chooseStaff() {
      this.$refs.selectStaff.open(this.form.audit)
    },
    handleStaffSelect(staff) {
      this.form.audit.staffId = staff.staffId
      this.form.audit.staffName = staff.staffName
    }
  }
}
</script>

<style lang="scss" scoped>
.add-item-release-view-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-md);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }

  &__body {
    padding: var(--ds-spacing-lg);
  }
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);

  &--standalone {
    background: #fff;
    border: 1px solid var(--ds-gray-300);
    border-radius: var(--ds-radius-md);
    box-shadow: var(--ds-shadow-sm);
    padding: var(--ds-spacing-md) var(--ds-spacing-lg);
  }
}
</style>
